import React, { useEffect } from "react";
import { User } from "../../../types";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
} from '@material-ui/core';

import { useQueryParams, StringParam, withDefault } from "use-query-params";

import { actions } from '../../../services/userTransactions';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { ReactWindowScroller } from "../../../components/WindowScroller";
import { FixedSizeList } from "react-window";
import UserTransactionItem from "./UserTransactionItem";

const Root = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  flex: 1,
});

interface Props {
  user: User;
}

const UserTransactions: React.FC<Props> = ({ user }) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.userTransactions);

  const [ filters, setFilters ] = useQueryParams({
    type: withDefault(StringParam, 'all'),
  });

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilters({
      [ event.target.name ]: event.target.value
    }, 'replaceIn');
  };

  useEffect(() => {
    dispatch(actions.loadTransactions(user.id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ user.id ]);

  if (state.loading || !state.transactions[ user.id ]) {
    return (
      <Root>
        <CircularProgress />
      </Root>
    );
  }

  return (
    <Root>
      <Stack direction="column" spacing={1} alignItems="flex-start" sx={{ width: '100%' }}>

        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            name="type"
            labelId="type-label"
            value={filters.type || 'all'}
            label="Type"
            onChange={handleFilterChange}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="iap_coinpack">Coinpack Purchase</MenuItem>
            <MenuItem value="buy_in_app_product">Buy In App Product</MenuItem>
            <MenuItem value="ad_reward">Ad Reward</MenuItem>
            <MenuItem value="user_credit">User Credit</MenuItem>
          </Select>
        </FormControl>

        <ReactWindowScroller>
          {({ ref, outerRef, style, onScroll }) => (
            <FixedSizeList
              ref={ref}
              outerRef={outerRef}
              style={style}
              onScroll={onScroll}
              height={window.innerHeight}
              width="100%"
              itemCount={state.transactions[user.id].length}
              itemSize={220}
              itemData={state.transactions[user.id]}
            >
              {UserTransactionItem}
            </FixedSizeList>
          )}
        </ReactWindowScroller>
      </Stack>
    </Root>
  );
};

export default UserTransactions;